import BaseDataTableWithSort from "./BaseDataTableWithSort";

export default BaseDataTableWithSort;
